import type { PlanSource } from "@/lib/types";
import { sourceMeta } from "./source-meta";

/* A small glowing LED dot signalling where a price came from. The color is
   backed by an accessible label: every dot carries title + aria-label, and the
   footer legend repeats the mapping, so the source is never color-only. */

interface SourceLedProps {
  source: PlanSource | null | undefined;
  /** Show the text label next to the dot (used in the legend). */
  withLabel?: boolean;
  className?: string;
}

export default function SourceLed({ source, withLabel, className }: SourceLedProps) {
  if (!source) return null;
  const meta = sourceMeta(source.source);
  const label = source.label || meta.label;

  return (
    <span
      className={
        "inline-flex items-center gap-1.5 " + (className ? className : "")
      }
    >
      <span
        className="inline-block h-2 w-2 shrink-0 rounded-full"
        style={{
          backgroundColor: meta.color,
          boxShadow: `0 0 0 2px ${meta.color}33, 0 0 4px ${meta.color}99`,
        }}
        role="img"
        aria-label={"Fare source: " + label}
        title={label}
      />
      {withLabel && (
        <span className="text-xs text-muted-foreground">{label}</span>
      )}
    </span>
  );
}
